import { createContext, useContext } from 'react';
const initialState = {
    getCountryAddressForm: ()=>undefined,
    addressTemplates: undefined
};
export const AddressFormsContext = createContext(initialState);
export const getAddressForm = (templates, country)=>{
    return templates?.find((template)=>template.country === country)?.template || templates?.find((template)=>template.country === 'COMMON')?.template;
};
export function useAddressForms() {
    const context = useContext(AddressFormsContext);
    if (context === undefined) {
        throw new Error('useAddressForms must be used within a AddressFormsContext');
    }
    return context;
}

//# sourceMappingURL=address-forms-context.js.map